import { computed } from "vue";
import { useStore } from "vuex";
import messages from "./messages";
import flatEn from "./flat-en";

function getNested(obj, path) {
    return path.split(".").reduce((acc, key) => (acc != null ? acc[key] : undefined), obj);
}

function hasChinese(str) {
    return typeof str === "string" && /[\u4e00-\u9fff]/.test(str);
}

function interpolate(text, params = {}) {
    if (!text || typeof text !== "string") return text;
    return text.replace(/\{(\w+)\}/g, (_, key) => (params[key] != null ? params[key] : `{${key}}`));
}

function pairZhEn(zhTree, enTree, out = {}) {
    Object.keys(zhTree || {}).forEach((k) => {
        if (zhTree[k] && typeof zhTree[k] === "object" && !Array.isArray(zhTree[k])) {
            pairZhEn(zhTree[k], (enTree || {})[k], out);
        } else if (typeof zhTree[k] === "string" && typeof (enTree || {})[k] === "string") {
            out[zhTree[k]] = enTree[k];
        }
    });
    return out;
}

const nestedEnMap = pairZhEn(messages.zh, messages.en);

export function translate(key, params = {}, locale) {
    const lang = locale || "zh";

    if (lang === "zh") {
        if (key && key.includes(".") && !hasChinese(key)) {
            const nested = getNested(messages.zh, key);
            if (nested != null) return interpolate(nested, params);
        }
        return interpolate(key, params);
    }

    if (hasChinese(key)) {
        const en =
            flatEn[key] ||
            nestedEnMap[key] ||
            key;
        return interpolate(en, params);
    }

    const text =
        getNested(messages.en, key) ??
        getNested(messages.zh, key) ??
        flatEn[key] ??
        nestedEnMap[key] ??
        key;
    return interpolate(text, params);
}

export function useI18n() {
    const store = useStore();
    const locale = computed(() => store.state.locale.locale);

    const t = (key, params = {}) => translate(key, params, locale.value);

    const toggleLocale = () => store.dispatch("locale/toggleLocale");

    return { locale, t, toggleLocale };
}
